<template>
  <div>
    <div class="text-right expand-collapse hyperlink">
      <SearchContactsModal
         modalId="'quickContactSearch'"
         :disableExisting="true"
         searchButtonText="New Contact Search"
         :isButton="false"
         @set-contact="setContact"
      />
    </div>
    <div class="card mb-2" ref="card">
      <div class="card-header bg-primary text-white d-flex">
        <span class="font-weight-bold">Contact Info</span>
      </div>
      <div class="card-body">
        <LoadingSpinner v-if="loading"
                        message ='Loading Contact' size = '1x'>
        </LoadingSpinner>
        <template v-else>
          <div class="row contact-name-row">
            <div class="col-lg-1 label-text">Name:</div>
            <div class="col-lg-11">{{ currentContact | contactName }}</div>
          </div>
          <div class="row">
            <div class="col-lg-1 label-text">
              Address:
            </div>
            <div class="col-lg-3" v-html="$options.filters.contactAddress(currentContact)">
            </div>
            <div class="col-lg-4">
              <span class="label-text">
                Email:
              </span>
              {{ contactField('email') }}
            </div>
            <div class="col-lg-4"
            v-if="currentContact.phones && currentContact.phones.length == 0">
              <span class="label-text">
                Phone:
              </span>
              None
            </div>
          </div>
          <hr v-if="currentContact.phones && currentContact.phones.length > 0">
          <div class="row mb-2">
            <div class="col-6 col-lg-3"
              v-for='phone in currentContact.phones'
              :key='phone.type'>
              <div class="label-text">{{ phone.type }}</div>
              <a :href="`tel:${phone.number}`">
                {{ phone.number }}
              </a>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="card mb-2" ref="card">
      <div class="card-header bg-primary text-white d-flex">
        <a v-b-toggle="`collapse-contact-instruments-card`"
           class="collapse-icon c-pointer">
          <font-awesome-icon class="when-opened" icon='caret-down' size="lg" />
            <font-awesome-icon class="when-closed fa-w-10" icon='caret-right' size="lg" />
        </a>
        <span class="font-weight-bold">
          Instruments
        </span>
      </div>
      <b-collapse visible :id="`collapse-contact-instruments-card`">
        <div class="card-body">
          <template
            v-if="currentContact">
            <div v-if="sortedInstruments === null || sortedInstruments.length === 0">
              This Contact is not associated to any Instruments
            </div>
            <template v-else>
              <div class="card listing-card col-12"
                v-for='instrument in sortedInstruments'
                :key='instrument.id'>
                <div class="card-body">
                  <div class="row mb-2">
                    <div class="col-sm-2">
                      <div class="list-header">
                        Project
                      </div>
                      <div class="list-details">
                        {{ instrument.projectId }} - {{ instrument.projectName }}
                      </div>
                    </div>
                    <div class="col-sm-2">
                      <div class="list-header">
                        Instrument ID
                      </div>
                      <div class="list-details">
                        {{ instrument.id }}
                      </div>
                    </div>
                    <div class="col-sm-2">
                      <div class="list-header">
                        Instrument Type
                      </div>
                      <div class="list-details">
                        {{ getInstrumentTypeName(instrument.typeId)  || 'None' }}
                      </div>
                    </div>
                    <div class="col-sm-2">
                      <div class="list-header">
                        Instrument Status
                      </div>
                      <div class="list-details">
                        {{ getInstrumentStatusName(instrument.statusId) }}
                      </div>
                    </div>
                    <div class="col-sm-2">
                      <div class="list-header">
                        Role(s)
                      </div>
                      <div class="list-details">
                        <div v-for="role in instrument.roles"
                          :key="instrument.id + '-' + role.name">
                          {{ role.name }}
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-2 d-flex contact-view-button align-self-start">
                      <div class="list-header">
                      </div>
                      <div class="list-details"
                        v-if="instrument">
                        <router-link
                          :to="{ name: 'projectInstrument', params: {
                          project_id: instrument.projectId,
                          id: instrument.id }}"
                          class="btn btn-secondary btn-sm"
                          >
                          View
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
               </div>
            </template>
          </template>
        </div>
      </b-collapse>
    </div>
    <div class="card mb-2" ref="card">
      <div class="card-header bg-primary text-white d-flex">
        <a v-b-toggle="`collapse-contact-properties-card`"
           class="collapse-icon c-pointer">
          <font-awesome-icon class="when-opened" icon='caret-down' size="lg" />
            <font-awesome-icon class="when-closed fa-w-10" icon='caret-right' size="lg" />
        </a>
        <span class="font-weight-bold">
          Properties
        </span>
      </div>
      <b-collapse visible :id="`collapse-contact-properties-card`">
        <div class="card-body">
          <template
            v-if="currentContact">
            <div v-if="sortedProperties === null || sortedProperties.length === 0">
              This Contact is not associated to any Properties
            </div>
            <template v-else>
              <div class="card listing-card col-12"
                v-for='property in sortedProperties'
                :key='property.id'>
                <div class="card-body">
                  <div class="row mb-2">
                    <div class="col-sm-2">
                      <div class="list-header">
                        Project
                      </div>
                      <div class="list-details">
                        {{ property.projectId }} - {{ property.projectName }}
                      </div>
                    </div>
                    <div class="col-sm-2">
                      <div class="list-header">
                        Property ID
                      </div>
                      <div class="list-details">
                        {{ property.id }}
                      </div>
                    </div>
                    <div class="col-sm-2">
                      <div class="list-header">
                        Property Name
                      </div>
                      <div class="list-details">
                        {{ property.name }}
                      </div>
                    </div>
                    <div class="col-sm-2">
                      <div class="list-header">
                        Property Status
                      </div>
                      <div class="list-details">
                        {{ getPropertyStatusName(property.statusId) }}
                      </div>
                    </div>
                    <div class="col-sm-2">
                      <div class="list-header">
                        Role(s)
                      </div>
                      <div class="list-details">
                        <div v-for="role in property.roles"
                          :key="property.id + '-' + role.name">
                          {{ role.name }}
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-2 d-flex contact-view-button align-self-start">
                      <div class="list-header">
                      </div>
                      <div class="list-details"
                        v-if="property">
                        <router-link
                          :to="{ name: 'projectProperty', params: {
                          project_id: property.projectId,
                          property_id: property.id }}"
                          class="btn btn-secondary btn-sm"
                          >
                          View
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </template>
        </div>
      </b-collapse>
    </div>
    <div class="card mb-2" ref="card">
      <div class="card-header bg-primary text-white d-flex">
        <a v-b-toggle="`collapse-contact-services-card`"
           class="collapse-icon c-pointer">
          <font-awesome-icon class="when-opened" icon='caret-down' size="lg" />
            <font-awesome-icon class="when-closed fa-w-10" icon='caret-right' size="lg" />
        </a>
        <span class="font-weight-bold">
          Services
        </span>
      </div>
      <b-collapse visible :id="`collapse-contact-services-card`">
        <div class="card-body">
          <template
            v-if="currentContact">
            <div v-if="sortedServices === null || sortedServices.length === 0">
              This Contact is not associated to any Services
            </div>
            <template v-else>
              <div class="card listing-card col-12"
                v-for='service in sortedServices'
                :key='service.id'>
                <div class="card-body">
                  <div class="row mb-2">
                    <div class="col-sm-2">
                      <div class="list-header">
                        Project
                      </div>
                      <div class="list-details">
                        {{ service.projectId }} - {{ service.projectName }}
                      </div>
                    </div>
                    <div class="col-sm-2">
                      <div class="list-header">
                        Service ID
                      </div>
                      <div class="list-details">
                        {{ service.id }}
                      </div>
                    </div>
                    <div class="col-sm-3">
                      <div class="list-header">
                        Service Component(s)
                      </div>
                      <div class="list-details">
                        <div v-for="typeId in service.typeIds"
                          :key="service.id + '-' + typeId">
                          {{ getServiceTypeName(typeId) }} -
                          {{ getServiceCategoryName(service.categoryId) }}
                        </div>
                        
                      </div>
                    </div>
                    <div class="col-sm-2">
                      <div class="list-header">
                        Service Status
                      </div>
                      <div class="list-details">
                        {{ getServiceStatusName(service.statusId) }}
                      </div>
                    </div>
                    <div class="col-sm-2">
                      <div class="list-header">
                        Role(s)
                      </div>
                      <div class="list-details">
                        <div v-for="role in service.roles"
                          :key="service.id + '-' + role.name">
                          {{ role.name }}
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-1 d-flex contact-view-button align-self-start">
                      <div class="list-header">
                      </div>
                      <div class="list-details"
                        v-if="service">
                        <router-link
                          :to="{ name: 'projectService', params: {
                          project_id: service.projectId,
                          id: service.id }}"
                          class="btn btn-secondary btn-sm"
                          >
                          View
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </template>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>

import { mapState, mapGetters } from 'vuex';
import { LookupModules } from '@/store/moduleConfig';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import SearchContactsModal from '@/components/contacts/SearchContactsModal.vue';

export default {
  name: 'Contact',
  components: {
    LoadingSpinner,
    SearchContactsModal,
  },
  mounted() {
    this.$store.dispatch('Contact/fetchContact', { id: this.$route.params.id });
    this.$store.dispatch(`${LookupModules.INSTRUMENT_TYPES.namespace}/fetchOptions`,
      LookupModules.INSTRUMENT_TYPES.url);
    this.$store.dispatch(`${LookupModules.INSTRUMENT_ROLES.namespace}/fetchOptions`,
      LookupModules.INSTRUMENT_ROLES.url);
    this.$store.dispatch(`${LookupModules.INSTRUMENT_STATUSES.namespace}/fetchOptions`,
      LookupModules.INSTRUMENT_STATUSES.url);
    this.$store.dispatch(`${LookupModules.PROPERTY_ROLES.namespace}/fetchOptions`,
      LookupModules.PROPERTY_ROLES.url);
    this.$store.dispatch(`${LookupModules.PROPERTY_STATUSES.namespace}/fetchOptions`,
      LookupModules.PROPERTY_STATUSES.url);
    this.$store.dispatch(`${LookupModules.PROPERTY_STATUSES.namespace}/fetchOptions`,
      LookupModules.PROPERTY_STATUSES.url);
    this.$store.dispatch(`${LookupModules.SERVICE_STATUSES.namespace}/fetchOptions`,
      LookupModules.SERVICE_STATUSES.url);
    this.$store.dispatch(`${LookupModules.SERVICE_CATEGORIES.namespace}/fetchOptions`,
      LookupModules.SERVICE_CATEGORIES.url);
    this.$store.dispatch(`${LookupModules.SERVICE_TYPES.namespace}/fetchOptions`,
      LookupModules.SERVICE_TYPES.url);
    this.$store.dispatch(`${LookupModules.SERVICE_ROLES.namespace}/fetchOptions`,
      LookupModules.SERVICE_ROLES.url);
  },
  computed: {
    ...mapState('Contact', {
      currentContact: state => state.currentContact,
      loading: state => state.loading,
      serverError: state => state.serverError,
    }),
    ...mapGetters(LookupModules.INSTRUMENT_TYPES.namespace, {
      getInstrumentTypeName: 'getName',
    }),
    ...mapGetters(LookupModules.INSTRUMENT_STATUSES.namespace, {
      getInstrumentStatusName: 'getName',
    }),
    ...mapGetters(LookupModules.INSTRUMENT_ROLES.namespace, {
      getInstrumentRoleName: 'getName',
    }),
    ...mapGetters(LookupModules.PROPERTY_ROLES.namespace, {
      getPropertyRoleName: 'getName',
    }),
    ...mapGetters(LookupModules.PROPERTY_STATUSES.namespace, {
      getPropertyStatusName: 'getName',
    }),
    ...mapGetters(LookupModules.SERVICE_STATUSES.namespace, {
      getServiceStatusName: 'getName',
    }),
    ...mapGetters(LookupModules.SERVICE_CATEGORIES.namespace, {
      getServiceCategoryName: 'getName',
    }),
    ...mapGetters(LookupModules.SERVICE_TYPES.namespace, {
      getServiceTypeName: 'getName',
    }),
    ...mapGetters(LookupModules.SERVICE_ROLES.namespace, {
      getServiceRoleName: 'getName',
    }),
    sortedInstruments() {
      return [].concat(this.currentContact.contactInstruments
        .filter(i => this.getInstrumentStatusName(i.statusId) === 'Pending').sort(this.entityCompare))
        .concat(this.currentContact.contactInstruments
          .filter(i => this.getInstrumentStatusName(i.statusId) === 'Active').sort(this.entityCompare))
        .concat(this.currentContact.contactInstruments
          .filter(i => this.getInstrumentStatusName(i.statusId) === 'Inactive').sort(this.entityCompare));
    },
    sortedProperties() {
      return [].concat(this.currentContact.contactProperties
        .filter(i => this.getPropertyStatusName(i.statusId) === 'Active').sort(this.entityCompare))
        .concat(this.currentContact.contactProperties
          .filter(i => this.getPropertyStatusName(i.statusId) === 'Inactive').sort(this.entityCompare));
    },
    sortedServices() {
      return [].concat(this.currentContact.contactServices
        .filter(i => this.getServiceStatusName(i.statusId) === 'Open').sort(this.entityCompare))
        .concat(this.currentContact.contactServices
          .filter(i => this.getServiceStatusName(i.statusId) === 'Closed').sort(this.entityCompare));
    },
  },
  methods: {
    entityCompare(a, b) {
      // if projects are the same, compary the entity Id
      if (a.projectId - b.projectId === 0) {
        return a.id - b.id;
      }
      return a.projectId - b.projectId;
    },
    contactField(fieldName) {
      if (!this.currentContact) {
        return '';
      }
      return this.currentContact[fieldName] ? this.currentContact[fieldName] : 'None';
    },
    setContact(contactResult) {
      this.$router.push({ name: 'contact', params: { id: contactResult.crmId } });
      this.$store.dispatch('Contact/fetchContact', { id: contactResult.crmId });
    },
  },
};
</script>
